import { UseDebouncedSuggestionAddressType } from 'application/hooks/useAddressState';

export enum PointCreateModalPages {
  POINT = 'POINT',
  STREAM = 'STREAM',
}

export enum PointCreateWithPaymentModalMode {
  HINT,
  CONFIRM,
}

export interface PointCreateModalProps {
  autoOpened?: boolean;
}

export interface UsePointCreateModalViewModel {
  addressState: UseDebouncedSuggestionAddressType;
  extendCost?: number;
  extendFullPeriodCost?: number;
  createPointError?: Error;
  userOnboardingFeaturesLoading: boolean;
  isButtonDisabled: boolean;
  isButtonLoading: boolean;
  isShowHintAboutPrice?: boolean;
  needShowAcceptanceAdvancedModal: boolean;
  isAcceptanceAdvancedNull: boolean;
  isAcceptanceAdvancedPending: boolean;
  canAddPointWithPayment?: boolean;
  withResidualPayment: boolean;
  formatNextBillingDate: string;
  fromTime: string;
  toTime: string;
  onFromTimeChange: (value: string) => void;
  onToTimeChange: (value: string) => void;
  onFromTimeBlur: () => void;
  onToTimeBlur: () => void;
  onCreatePointButtonClick: () => void;
  openAcceptanceAdvancedSigning: () => void;
}
